<template>
  <main-template>
    <v-row>
      <v-col>
        <div class="d-flex justify-space-between align-center">
          <h1>
            <v-btn color="primary" x-small text @click="goBack">
              <v-icon left> fa fa-angle-left </v-icon>
            </v-btn>
            Ponto dos Colaboradores
            <e-help-tooltip
              text="Gestão e auditoria de batidas de ponto dos colaboradores, com lançamentos manuais, ajustes e histórico de auditoria."
            />
          </h1>

          <div>
            <v-btn
              color="info"
              outlined
              class="mr-2"
              :disabled="!colaboradorId"
              @click="abrirHistorico"
            >
              <v-icon left small>mdi-history</v-icon>
              Histórico de Alterações
            </v-btn>

            <v-btn color="primary" :disabled="!colaboradorId" @click="abrirCriarBatida(hoje())">
              <v-icon left small>mdi-plus</v-icon>
              Lançar Registro Manual
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="colaboradorId"
                  :items="colaboradores"
                  item-text="nome"
                  item-value="id"
                  label="Selecione o Colaborador"
                  outlined
                  dense
                  clearable
                />
              </v-col>
            </v-row>

            <horario-tabs v-model="tab" class="mb-4" />

            <div v-if="tab === 0">
              <horario-dia-filtro
                v-model="dataSelecionada"
                class="mb-3"
                :disabled="!colaboradorId"
                @buscar="buscarDia"
              />

              <horario-lista-agrupada
                :registros="registrosDia"
                modo-admin
                comprovante-service="colaborador"
                @nova-batida="abrirCriarBatida"
                @editar-batida="abrirEditarBatida"
                @excluir-batida="solicitarExclusao"
              />
            </div>

            <div v-if="tab === 1">
              <v-btn
                color="primary"
                class="mb-3"
                :disabled="!colaboradorId"
                @click="buscarUltimos10Dias"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Atualizar
              </v-btn>
              <horario-lista-agrupada
                :registros="registrosUltimos10Dias"
                modo-admin
                comprovante-service="colaborador"
                @nova-batida="abrirCriarBatida"
                @editar-batida="abrirEditarBatida"
                @excluir-batida="solicitarExclusao"
              />
            </div>

            <div v-if="tab === 2">
              <horario-periodo-filtro
                v-model="periodo"
                class="mb-3"
                :disabled="!colaboradorId"
                @buscar="buscarPeriodo"
                @gerar-pdf="gerarPdfPeriodo"
              />
              <horario-lista-agrupada
                :registros="registrosPeriodo"
                modo-admin
                comprovante-service="colaborador"
                @nova-batida="abrirCriarBatida"
                @editar-batida="abrirEditarBatida"
                @excluir-batida="solicitarExclusao"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <e-modal-espelho-ponto-pdf
      :dialog="dialogPdf"
      :pdf="pdf"
      title="Espelho de Ponto"
      @close="fecharPdf"
    />

    <v-dialog v-model="dialogBatidaForm" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-3">
          {{ modoEdicao ? "Editar Registro de Ponto" : "Lançar Registro Manual" }}
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="formBatida" v-model="formValido">
            <v-text-field
              v-model="formBatida.data"
              label="Data da Batida"
              type="date"
              outlined
              dense
              :rules="[rules.required]"
            />

            <v-text-field
              v-model="formBatida.hora"
              label="Horário (HH:MM)"
              type="time"
              outlined
              dense
              :rules="[rules.required]"
            />

            <v-text-field
              v-model="formBatida.tipo_evento"
              label="Tipo (opcional)"
              placeholder="Ex.: Entrada, Saída, Ajuste"
              outlined
              dense
              maxlength="100"
            />

            <v-textarea
              v-model="formBatida.justificativa"
              label="Justificativa (Mínimo 10 caracteres)"
              outlined
              dense
              rows="3"
              counter="500"
              :rules="[rules.required, rules.minJustificativa]"
            />
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0 justify-end">
          <v-btn text @click="dialogBatidaForm = false">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="salvandoBatida"
            :disabled="
              !formValido ||
              salvandoBatida ||
              !formBatida.justificativa ||
              formBatida.justificativa.length < 10 ||
              formBatida.justificativa.length > 500
            "
            @click="salvarBatida"
          >
            Salvar Registro
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogExclusao" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline red lighten-4 red--text text--darken-4">
          Confirmar Exclusão de Registro de Ponto
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert type="warning" dense outlined>
            Esta ação excluirá a registro de
            <strong>{{ batidaParaExcluir?.hora_formatada || batidaParaExcluir?.hora }}</strong> do
            dia <strong>{{ batidaParaExcluir?.data_formatada || batidaParaExcluir?.data }}</strong
            >. A jornada será recalculada automaticamente.
          </v-alert>

          <v-textarea
            v-model="justificativaExclusao"
            label="Justificativa da Exclusão (Mínimo 10 caracteres)"
            outlined
            dense
            rows="3"
            counter="500"
            :rules="[rules.required, rules.minJustificativa]"
          />
        </v-card-text>
        <v-card-actions class="pa-4 pt-0 justify-end">
          <v-btn text @click="dialogExclusao = false">Cancelar</v-btn>
          <v-btn
            color="error"
            :loading="excluindoBatida"
            :disabled="
              excluindoBatida ||
              !justificativaExclusao ||
              justificativaExclusao.length < 10 ||
              justificativaExclusao.length > 500
            "
            @click="confirmarExclusao"
          >
            Confirmar Exclusão
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogHistorico" max-width="900px">
      <v-card>
        <v-card-title class="headline grey lighten-3 d-flex justify-space-between align-center">
          <span>Histórico de Alterações de registros</span>
          <v-btn icon @click="dialogHistorico = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-data-table
            :headers="headersHistorico"
            :items="historico"
            :loading="carregandoHistorico"
            no-data-text="Nenhum registro de alteração encontrado no histórico."
            dense
          >
            <template v-slot:item.created_at="{ item }">
              {{ formatarDataHora(item.created_at) }}
            </template>
            <template v-slot:item.acao="{ item }">
              <v-chip
                :color="acaoColor(item.acao)"
                small
                dark
                class="text-uppercase font-weight-bold"
              >
                {{ item.acao }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </main-template>
</template>

<script>
import HorarioTabs from "@/components/Instrutores/HorarioTabs.vue";
import HorarioDiaFiltro from "@/components/Instrutores/HorarioDiaFiltro.vue";
import HorarioPeriodoFiltro from "@/components/Instrutores/HorarioPeriodoFiltro.vue";
import HorarioListaAgrupada from "@/components/Instrutores/HorarioListaAgrupada.vue";
import EModalEspelhoPontoPdf from "@/components/Instrutores/EModalEspelhoPontoPdf.vue";

const hoje = () => new Date().toISOString().slice(0, 10);

export default {
  name: "ColaboradoresPontosAdminPage",
  components: {
    HorarioTabs,
    HorarioDiaFiltro,
    HorarioPeriodoFiltro,
    HorarioListaAgrupada,
    EModalEspelhoPontoPdf,
  },
  data() {
    return {
      tab: 0,
      colaboradorId: null,
      colaboradores: [],
      dataSelecionada: hoje(),
      periodo: [],
      registrosDia: [],
      registrosUltimos10Dias: {},
      registrosPeriodo: {},
      dialogPdf: false,
      pdf: null,

      dialogBatidaForm: false,
      modoEdicao: false,
      formValido: false,
      salvandoBatida: false,
      formBatida: {
        id: null,
        colaborador_user_id: null,
        data: hoje(),
        hora: "",
        tipo_evento: "",
        justificativa: "",
      },

      dialogExclusao: false,
      batidaParaExcluir: null,
      justificativaExclusao: "",
      excluindoBatida: false,

      dialogHistorico: false,
      carregandoHistorico: false,
      historico: [],
      headersHistorico: [
        { text: "Data/Hora Alteração", value: "created_at" },
        { text: "Ação", value: "acao" },
        { text: "Antes", value: "dados_anteriores" },
        { text: "Depois", value: "dados_novos" },
        { text: "Justificativa", value: "justificativa" },
        { text: "Responsável", value: "usuario_responsavel_nome" },
      ],

      rules: {
        required: (v) => !!v || "Campo obrigatório.",
        minJustificativa: (v) =>
          (v && v.length >= 10) || "Justificativa deve conter no mínimo 10 caracteres.",
      },
    };
  },
  watch: {
    colaboradorId() {
      this.registrosDia = [];
      this.registrosUltimos10Dias = {};
      this.registrosPeriodo = {};
      if (this.colaboradorId) {
        this.buscarDia();
      }
    },
  },
  mounted() {
    this.carregarColaboradores();
  },
  beforeDestroy() {
    this.limparPdfAtual();
  },
  methods: {
    hoje,
    goBack() {
      this.$goBack();
    },
    async carregarColaboradores() {
      try {
        this.$loaderService.open("Carregando colaboradores");
        const res = await this.$services.colaboradorPontosService.listarColaboradores();
        this.colaboradores = Array.isArray(res) ? res : res.data || [];
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async buscarDia() {
      if (!this.colaboradorId) return;
      try {
        this.$loaderService.open("Carregando pontos do colaborador");
        this.registrosDia = await this.$services.colaboradorPontosService.adminPontosDia({
          colaborador_id: this.colaboradorId,
          data: this.dataSelecionada,
        });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async buscarUltimos10Dias() {
      if (!this.colaboradorId) return;
      try {
        this.$loaderService.open("Carregando últimos 10 dias");
        this.registrosUltimos10Dias =
          await this.$services.colaboradorPontosService.adminPontosUltimos10Dias({
            colaborador_id: this.colaboradorId,
          });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async buscarPeriodo(form) {
      if (!this.colaboradorId || !form.data_inicio || !form.data_fim) return;
      try {
        this.$loaderService.open("Carregando período");
        this.registrosPeriodo = await this.$services.colaboradorPontosService.adminPontosPeriodo({
          colaborador_id: this.colaboradorId,
          ...form,
        });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async gerarPdfPeriodo(form) {
      if (!this.colaboradorId || !form.data_inicio || !form.data_fim) return;
      try {
        this.$loaderService.open("Gerando espelho de ponto");
        this.limparPdfAtual();
        this.pdf = await this.$services.colaboradorPontosService.adminPontosPeriodoPdf({
          colaborador_id: this.colaboradorId,
          ...form,
        });
        this.dialogPdf = true;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    abrirCriarBatida(data) {
      this.modoEdicao = false;
      this.formBatida = {
        id: null,
        colaborador_user_id: this.colaboradorId,
        data: data || hoje(),
        hora: "",
        tipo_evento: "",
        justificativa: "",
      };
      this.dialogBatidaForm = true;
    },
    abrirEditarBatida(item) {
      this.modoEdicao = true;
      this.formBatida = {
        id: item.id,
        colaborador_user_id: this.colaboradorId,
        data: item.data || hoje(),
        hora: (item.hora || "").slice(0, 5),
        tipo_evento: item.tipo_evento || "",
        justificativa: "",
      };
      this.dialogBatidaForm = true;
    },
    async salvarBatida() {
      if (!this.$refs.formBatida.validate()) return;
      try {
        this.salvandoBatida = true;
        const dados = {
          colaborador_user_id: this.colaboradorId,
          data: this.formBatida.data,
          hora: this.formBatida.hora,
          tipo_evento: this.formBatida.tipo_evento || null,
          justificativa: this.formBatida.justificativa,
        };

        if (this.modoEdicao) {
          await this.$services.colaboradorPontosService.editarBatida(this.formBatida.id, dados);
        } else {
          await this.$services.colaboradorPontosService.criarBatida(dados);
        }

        this.dialogBatidaForm = false;
        this.recarregarConsultaAtiva();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.salvandoBatida = false;
      }
    },
    solicitarExclusao(item) {
      this.batidaParaExcluir = item;
      this.justificativaExclusao = "";
      this.dialogExclusao = true;
    },
    async confirmarExclusao() {
      if (
        !this.batidaParaExcluir ||
        this.justificativaExclusao.length < 10 ||
        this.justificativaExclusao.length > 500
      ) {
        return;
      }
      try {
        this.excluindoBatida = true;
        await this.$services.colaboradorPontosService.excluirBatida(this.batidaParaExcluir.id, {
          justificativa: this.justificativaExclusao,
        });
        this.dialogExclusao = false;
        this.recarregarConsultaAtiva();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.excluindoBatida = false;
      }
    },
    recarregarConsultaAtiva() {
      if (this.tab === 0 && this.registrosDia !== null) this.buscarDia();
      else if (this.tab === 1 && this.registrosUltimos10Dias !== null) this.buscarUltimos10Dias();
    },
    async abrirHistorico() {
      if (!this.colaboradorId) return;
      try {
        this.dialogHistorico = true;
        this.carregandoHistorico = true;
        const res = await this.$services.colaboradorPontosService.historicoAjustesBatidas(
          this.colaboradorId
        );
        this.historico = Array.isArray(res) ? res : res.data || [];
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregandoHistorico = false;
      }
    },
    fecharPdf() {
      this.dialogPdf = false;
      this.limparPdfAtual();
    },
    limparPdfAtual() {
      if (this.pdf) {
        window.URL.revokeObjectURL(this.pdf);
        this.pdf = null;
      }
    },
    formatarDataHora(val) {
      if (!val) return "";
      return new Date(val).toLocaleString("pt-BR");
    },
    acaoColor(acao) {
      switch (String(acao).toLowerCase()) {
        case "criado":
        case "criacao":
        case "criacao_manual":
          return "success";
        case "editado":
        case "edicao":
          return "warning";
        case "excluido":
        case "exclusao":
          return "error";
        default:
          return "info";
      }
    },
  },
};
</script>
